import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as ConveyorAPI from './conveyorAPI';

export const readConveyor = createAsyncThunk('conveyor/read', async (id, { rejectWithValue }) => {
    try {
        const response = await ConveyorAPI.readConveyor(id);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

const initialState = {
    conveyor: null,
    error: null,
};

const conveyorSlice = createSlice({
    name: 'conveyor',
    initialState,
    reducers: {
        unloadConveyor: state => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(readConveyor.fulfilled, (state, { payload }) => {
                state.conveyor = payload;
                state.error = null;
            })
            .addCase(readConveyor.rejected, (state, { payload }) => {
                state.conveyor = null;
                state.error = payload;
            })
    },
});

export const { unloadConveyor } = conveyorSlice.actions;
export default conveyorSlice.reducer;